var _defs, _g, _g2, _g3, _g4, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHeroIconViz1Onclick = function SvgHeroIconViz1Onclick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 26
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".hero-icon-viz1-onclick_svg__a{fill:#fff;stroke:#005dfd;stroke-width:2px}.hero-icon-viz1-onclick_svg__b{stroke:none}.hero-icon-viz1-onclick_svg__c{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "hero-icon-viz1-onclick_svg__a",
    transform: "translate(9 12)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "hero-icon-viz1-onclick_svg__b",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "hero-icon-viz1-onclick_svg__c",
    cx: 7,
    cy: 7,
    r: 6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "hero-icon-viz1-onclick_svg__a",
    transform: "translate(19)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "hero-icon-viz1-onclick_svg__b",
    cx: 5.5,
    cy: 5.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "hero-icon-viz1-onclick_svg__c",
    cx: 5.5,
    cy: 5.5,
    r: 4.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "hero-icon-viz1-onclick_svg__a",
    transform: "translate(7 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "hero-icon-viz1-onclick_svg__b",
    cx: 3.5,
    cy: 3.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "hero-icon-viz1-onclick_svg__c",
    cx: 3.5,
    cy: 3.5,
    r: 2.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "hero-icon-viz1-onclick_svg__a",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "hero-icon-viz1-onclick_svg__b",
    cx: 3.5,
    cy: 3.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "hero-icon-viz1-onclick_svg__c",
    cx: 3.5,
    cy: 3.5,
    r: 2.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "hero-icon-viz1-onclick_svg__a",
    transform: "translate(25 13)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "hero-icon-viz1-onclick_svg__b",
    cx: 3.5,
    cy: 3.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "hero-icon-viz1-onclick_svg__c",
    cx: 3.5,
    cy: 3.5,
    r: 2.5
  }))));
};

export { SvgHeroIconViz1Onclick as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='32' height='26' viewBox='0 0 32 26'%3e%3cdefs%3e%3cstyle%3e.a%7bfill:%23fff;stroke:%23005dfd;stroke-width:2px;%7d.b%7bstroke:none;%7d.c%7bfill:none;%7d%3c/style%3e%3c/defs%3e%3cg transform='translate(-1076 -256)'%3e%3cg class='a' transform='translate(1085 268)'%3e%3ccircle class='b' cx='7' cy='7' r='7'/%3e%3ccircle class='c' cx='7' cy='7' r='6'/%3e%3c/g%3e%3cg class='a' transform='translate(1095 256)'%3e%3ccircle class='b' cx='5.5' cy='5.5' r='5.5'/%3e%3ccircle class='c' cx='5.5' cy='5.5' r='4.5'/%3e%3c/g%3e%3cg class='a' transform='translate(1083 259)'%3e%3ccircle class='b' cx='3.5' cy='3.5' r='3.5'/%3e%3ccircle class='c' cx='3.5' cy='3.5' r='2.5'/%3e%3c/g%3e%3cg class='a' transform='translate(1076 267)'%3e%3ccircle class='b' cx='3.5' cy='3.5' r='3.5'/%3e%3ccircle class='c' cx='3.5' cy='3.5' r='2.5'/%3e%3c/g%3e%3cg class='a' transform='translate(1101 269)'%3e%3ccircle class='b' cx='3.5' cy='3.5' r='3.5'/%3e%3ccircle class='c' cx='3.5' cy='3.5' r='2.5'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";